import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { LoginModule } from "./login/login.module";
import { AdminModule } from "./admin/admin.module";
import { CoreModule } from "./core/core.module";
/**for bd,nsm,rsm */
import { AddpolicyComponent } from "./addpolicy/addpolicy.component";
/**for workshop */
import { NxTabsModule } from "@allianz/ng-aquila/tabs";
import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxFormfieldModule } from "@allianz/ng-aquila/formfield";
import { NxInputModule } from "@allianz/ng-aquila/input";
import { NxDropdownModule } from "@allianz/ng-aquila/dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NxDatefieldModule } from "@allianz/ng-aquila/datefield";
import { NxNativeDateModule } from "@allianz/ng-aquila/datefield";
import { NxMomentDateModule } from "@allianz/ng-aquila/moment-date-adapter";
import { NxCheckboxModule } from "@allianz/ng-aquila/checkbox";
import { NxButtonModule } from "@allianz/ng-aquila/button";
import { NxIconModule } from "@allianz/ng-aquila/icon";
import { NxTableModule, NxSortHeaderIntl } from "@allianz/ng-aquila/table";
import { NxBadgeModule } from "@allianz/ng-aquila/badge";
import { NxSwitcherModule } from "@allianz/ng-aquila/switcher";
import { NxHeaderModule } from "@allianz/ng-aquila/header";
import { NxImageModule } from "@allianz/ng-aquila/image";
import { NxLinkModule } from "@allianz/ng-aquila/link";
import { NxPopoverModule } from "@allianz/ng-aquila/popover";
import { WorkshopregistrationComponent } from "./workshopregistration/workshopregistration.component";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxSpinnerModule } from "@allianz/ng-aquila/spinner";
import { AllianzIconModule } from '@allianz/ngx-brand-kit/icon';
import { NxSmallStageModule } from '@allianz/ng-aquila/small-stage';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClientXsrfModule,
  HttpClient,
  provideHttpClient, withFetch
} from "@angular/common/http";
//OpenIdIntegartion
import { AuthModule } from "angular-auth-oidc-client";
import { AuthInterceptor } from "./http.interceptor";
import { NxMessageModule } from "@allianz/ng-aquila/message";
import { VehicledetailsComponent } from "./vehicledetails/vehicledetails.component";
import { PlandetailsComponent } from "./plandetails/plandetails.component";
import { CustomerdetailsComponent } from "./customerdetails/customerdetails.component";
import { PaymentdetailsComponent } from "./paymentdetails/paymentdetails.component";
import { TitleModule } from "./title/title.module";
import { NxModalModule } from "@allianz/ng-aquila/modal";
import { NxCircleToggleModule } from "@allianz/ng-aquila/circle-toggle";
import { DownloadComponent } from "./download/download.component";
import { NxCardModule } from "@allianz/ng-aquila/card";
import { UserTypeComponent } from "./user-type/user-type.component";
import { UserPermissionsComponent } from "./user-permissions/user-permissions.component";
import { LoaderComponent } from "./loader/loader.component";
import { EventEmitterService } from "./event-emitter.service";
import { SortingService } from "./sorting.service";
import { NxMaskModule } from "@allianz/ng-aquila/mask";
import { NxPageSearchModule } from "@allianz/ng-aquila/page-search";
import { LoginResolve } from "./login/login.resolve";
import { RecaptchaModule } from "ng-recaptcha";
import { JsonAppConfigService } from "src/config/json-app-config.service";
import { AppConfig } from "src/config/app.config";
import { NxProgressbarModule } from "@allianz/ng-aquila/progressbar";
import { NxProgressStepperModule } from "@allianz/ng-aquila/progress-stepper";
import { UserReportsComponent } from "./user-reports/user-reports.component";

const oidc_configuration = "assets/auth.clientConfiguration.json";
const oidcConfig = {
  authority: 'https://your-identity-provider',
  clientId: 'your-client-id',
  redirectUrl: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email',
  silentRenew: true,
  useRefreshToken: true
};

//To load config from app.config.json
export function initializerFn(jsonAppConfigService: JsonAppConfigService) {
  return () => {
    jsonAppConfigService.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    AddpolicyComponent,
    WorkshopregistrationComponent,
    VehicledetailsComponent,
    PlandetailsComponent,
    CustomerdetailsComponent,
    PaymentdetailsComponent,
    DownloadComponent,
    UserTypeComponent,
    UserPermissionsComponent,
    LoaderComponent,
    UserReportsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    LoginModule,
    AdminModule,
    CoreModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: "XSRF-TOKEN",
      headerName: "X-XSRF-TOKEN",
    }),
    BrowserAnimationsModule,
    NxTabsModule,
    NxGridModule,
    NxFormfieldModule,
    NxInputModule,
    NxDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    NxDatefieldModule,
    NxNativeDateModule,
    NxMomentDateModule,
    NxCheckboxModule,
    NxButtonModule,
    NxIconModule,
    NxTableModule,
    NxBadgeModule,
    NxSwitcherModule,
    NxHeaderModule,
    NxImageModule,
    NxLinkModule,
    NxSpinnerModule,
    NxPopoverModule,
    AuthModule.forRoot({
      config: oidcConfig
    }),
    NxMessageModule,
    NxHeadlineModule,
    TitleModule,
    NxModalModule,
    NxCircleToggleModule,
    NxCardModule,
    NxMaskModule,
    NxPageSearchModule,
    RecaptchaModule,
    NxProgressbarModule,
    NxProgressStepperModule,
    AllianzIconModule,
    NxSmallStageModule,
  ],
  exports: [AddpolicyComponent, WorkshopregistrationComponent],
  providers: [
    provideHttpClient(withFetch()),
    EventEmitterService,
    { provide: NxSortHeaderIntl, useClass: SortingService },
    LoginResolve,
    {
      provide: AppConfig,
      deps: [HttpClient],
      useExisting: JsonAppConfigService,
    },
    provideAppInitializer(() => {
      const configService = inject(JsonAppConfigService);

      const initializerFn = () => configService.load();
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
